import { render, staticRenderFns } from "./UiBtn.vue?vue&type=template&id=149087ac"
import script from "./UiBtn.vue?vue&type=script&lang=js"
export * from "./UiBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('149087ac')) {
      api.createRecord('149087ac', component.options)
    } else {
      api.reload('149087ac', component.options)
    }
    module.hot.accept("./UiBtn.vue?vue&type=template&id=149087ac", function () {
      api.rerender('149087ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui-btn/UiBtn.vue"
export default component.exports